import { LitElement, html, css } from 'lit';

export class DataVisualization extends LitElement {
    static properties = {
        spec: { type: Object },
        loading: { type: Boolean },
        curTime: { type: Number }
    };

    static styles = css`
        .chart-container {
            width: 100%;
            height: 100%;
            min-height: 400px;
        }
        .loading-mask {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: rgba(255, 255, 255, 0.7);
            z-index: 1000;
        }
    `;

    constructor() {
        super();
        this.spec = {
            "type": "line",
            "point": {
                "visible": false
            },
            data: [
                {
                    id: 'hard0',
                    values: [{x: 0, y: -1, contraint: 'hard0'}]
                },
                {
                    id: 'hard1',
                    values: []
                },
                {
                    id: 'hard2',
                    values: [{x: 0, y: -1, contraint: 'hard2'}]
                },
                {
                    id: 'soft0',
                    values: []
                },
                {
                    id: 'soft1',
                    values: []
                },
                {
                    id: 'soft2',
                    values: []
                },
                {
                    id: 'soft3',
                    values: []
                },
                {
                    id: 'soft4',
                    values: []
                }
            ],
            series: [
                {
                    type: 'line',
                    id: 'hard0',
                    dataId: 'hard0',
                    seriesField: 'contraint',
                    xField: 'x',
                    yField: 'y',
                    stack: false
                }, {
                    type: 'line',
                    id: 'hard1',
                    dataId: 'hard1',
                    seriesField: 'contraint',
                    xField: 'x',
                    yField: 'y',
                    stack: false
                },
                {
                    type: 'line',
                    id: 'hard2',
                    dataId: 'hard2',
                    seriesField: 'contraint',
                    xField: 'x',
                    yField: 'y',
                    stack: false
                },
                {
                    type: 'line',
                    id: 'soft0',
                    dataId: 'soft0',
                    seriesField: 'contraint',
                    xField: 'x',
                    yField: 'y',
                    stack: false
                },
                {
                    type: 'line',
                    id: 'soft1',
                    dataId: 'soft1',
                    seriesField: 'contraint',
                    xField: 'x',
                    yField: 'y',
                    stack: false
                },
                {
                    type: 'line',
                    id: 'soft2',
                    dataId: 'soft2',
                    seriesField: 'contraint',
                    xField: 'x',
                    yField: 'y',
                    stack: false
                },
                {
                    type: 'line',
                    id: 'soft3',
                    dataId: 'soft3',
                    seriesField: 'contraint',
                    xField: 'x',
                    yField: 'y',
                },
                {
                    type: 'line',
                    id: 'soft4',
                    dataId: 'soft4',
                    seriesField: 'contraint',
                    xField: 'x',
                    yField: 'y',
                }
            ],
            seriesField: 'contraint',
            animationAppear: {
                duration: 1500,
                easing: 'linear'
            },
            legends: [{ visible: true, position: 'middle', orient: 'bottom' }],
            axes: [
                {
                    orient: 'left',
                    seriesIndex: [0, 2],
                    label: {
                        formatMethod(val) {
                            return `${(val / 1000000000).toFixed(1)}`;
                        }
                    }
                },
                {
                    orient: 'left',
                    seriesIndex: [1],
                    label: {
                        formatMethod(val) {
                            return `${(val / 1000000000).toFixed(1)}`;
                        }
                    }
                },
                {
                    orient: 'right',
                    seriesIndex: [3, 4, 5, 7],
                    label: {
                        formatMethod(val) {
                            return `${(val / 1000000000).toFixed(1)}`;
                        }
                    }
                },
                {
                    orient: 'right',
                    seriesIndex: [6],
                    label: {
                        formatMethod(val) {
                            return `${(val / 1000000000).toFixed(1)}`;
                        }
                    }
                },
            ]
        };
        this.curTime = 0;
        this.loading = false;
        this._chart = null;
        this.addEventListener('receive-data', this.handleReceiveData);
    }


    handleReceiveData(event) {
        console.log('收到数据事件:', event);
        console.log('事件详情:', event.detail);

        if (event.detail && event.detail.score) {
            const score = event.detail.score;
            console.log('接收到新数据:', score);

            const hardScore = score?.hardScores;
            const softScore = score?.softScores;
            const spec = Object.assign({}, this.spec);
            const updateAxis = (axis, newValue) => {
                // axis.min = Math.min(axis.min || -10, newValue);
                // axis.max = Math.max(axis.max, newValue) || 0;
            }
            // 更新hard数据
            hardScore?.forEach((element, index) => {
                if (spec.data[index]) { // hard0, hard1, hard2
                    spec.data[index].values.push({
                        x: this.curTime,
                        y: element || 0,
                        contraint: `hard${index}`
                    });
                    updateAxis(spec.axes[index], element);
                }
            });

            // 更新soft数据
            softScore?.forEach((element, index) => {
                const softIndex = index + 3; // soft0从data[3]开始
                if (spec.data[softIndex]) { // soft0, soft1, soft2, soft3, soft4
                    spec.data[softIndex].values.push({
                        x: this.curTime,
                        y: element || 0,
                        contraint: `soft${index}`
                    });
                    updateAxis(spec.axes[softIndex], element);
                }
            });
            this.spec = spec;

            console.log('图表spec已更新');
            this.curTime++;
        }
    }

    render() {
        return html`
            <div class="chart-container" id="chart"></div>
            ${this.loading ? html`<div class="loading-mask">Loading...</div>` : ''}
        `;
    }

    firstUpdated() {
        this.initChart();
    }

    initChart() {
        const container = this.renderRoot.querySelector('#chart');
        this._chart = new VChart.default(this.spec, { dom: container });
        this._chart.renderAsync();
    }

    updated(changedProperties) {
        if (changedProperties.has('spec') && this._chart) {
            this._chart.updateSpec(this.spec);
        }
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        if (this._chart) {
            this._chart.release();
            this._chart = null;
        }
    }
}

customElements.define('data-visualization', DataVisualization);